import { Outlet } from "react-router";

const Scheme = () => {
	return <Outlet />;
};

export default Scheme;
